import { useState } from "react";
import { useFetch } from "../../lib/useData";
import { PageTitle, TableWrap } from "../../components/admin/ui";
const PAGE_SIZES = [10, 50, 100, 500, 1000];

export default function AuditLog() {
  const { data: logs, loading } = useFetch("/admin/audit-logs");
  const [pageSize, setPageSize] = useState(10);
const [page, setPage] = useState(1);

const allRows = logs || [];
const total = allRows.length;
const totalPages = Math.max(1, Math.ceil(total / pageSize));
const currentPage = Math.min(page, totalPages);
const start = (currentPage - 1) * pageSize;
const pagedRows = allRows.slice(start, start + pageSize);
  return (
    <div>
      <PageTitle title="Audit Log" desc="All sensitive actions performed by admin users" />
      <TableWrap>
        <thead className="bg-slate-800 text-slate-400"><tr>
          <th className="text-left px-4 py-3">Time</th><th className="text-left px-4 py-3">User</th><th className="text-left px-4 py-3">Role</th><th className="text-left px-4 py-3">Action</th><th className="text-left px-4 py-3">Module</th><th className="text-left px-4 py-3">Record</th>
        </tr></thead>
        <tbody className="divide-y divide-slate-700" data-testid="audit-table">
          {loading ? <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-500">Loading…</td></tr> :
pagedRows.map((l) => (
                <tr key={l.id} className="hover:bg-slate-800/50">
                <td className="px-4 py-3 text-slate-400 text-xs">{new Date(l.timestamp).toLocaleString()}</td>
                <td className="px-4 py-3">{l.user_name || l.user_email}</td>
                <td className="px-4 py-3 capitalize text-slate-400">{l.role?.replace(/_/g, " ")}</td>
                <td className="px-4 py-3"><span className="text-xs font-semibold bg-slate-700 rounded px-2 py-1">{l.action}</span></td>
                <td className="px-4 py-3 text-slate-300">{l.module}</td>
                <td className="px-4 py-3 text-slate-400 text-xs">{l.record_id || "—"}</td>
              </tr>
            ))}
          {!loading && (logs || []).length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-500">No audit entries yet</td></tr>}
        </tbody>
      </TableWrap>
      {!loading && total > 0 && (
  <div className="flex flex-wrap items-center justify-between gap-3 mt-4 text-sm text-slate-300">
    <div className="flex items-center gap-2">
      <span>Show</span>
      <select
        value={pageSize}
        onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
        className="bg-slate-800 border border-slate-700 rounded-lg px-2 py-1.5 text-slate-200"
        data-testid="audit-page-size"
      >
        {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
      <span>per page</span>
    </div>

    <span className="text-slate-400">
      {start + 1}–{Math.min(start + pageSize, total)} of {total}
    </span>

    <div className="flex items-center gap-2">
      <button
        onClick={() => setPage(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1.5 rounded-lg bg-slate-800 border border-slate-700 hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed"
      >Prev</button>
      <span>{currentPage} / {totalPages}</span>
      <button
        onClick={() => setPage(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1.5 rounded-lg bg-slate-800 border border-slate-700 hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed"
      >Next</button>
    </div>
  </div>
)}
    </div>
  );
}
